import { demoData} from '@/config/video.config'
const demo = {
    state: {
        name: null,
        video: null,
        key: null,
        minus: false
    },
    getters: {

    },
    mutations: {
        DEMO_SET_MINUS: (state, minus) => {
            state.minus = minus
        },
        DEMO_SET_NAME: (state, name) => {
            state.name = name
        },
        DEMO_SET_VIDEO: (state, video) => {
            state.video = video
        },
        DEMO_SET_KEY: (state, key) => {
            state.key = key
        },
        DEMO_STOP: (state) => {
            state.name = null
            state.video = null
            state.key = null
        }
    },

    actions: {
        demoSetVideo({ commit }, key){
            const obj = demoData.find((item)=>{
                return item.key == key
            })
            commit('DEMO_SET_NAME', obj.name)
            commit('DEMO_SET_VIDEO', obj.video)
            commit('DEMO_SET_KEY', obj.key)
            commit('DEMO_SET_MINUS', false)
        }
    }
}

export default demo
